module.exports = __webpack_public_path__ + "h5/img/openByBrowser.a0201e24.png";